import React, { useEffect, useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import style from "../../css/Navlinkpage/Aboutus.module.css";



gsap.registerPlugin(ScrollTrigger);

const Aboutus = () => {
    const sectionRef = useRef(null);
    const titleRef = useRef(null);
    const textRef = useRef(null);
    const cardsRef = useRef([]);
    const imagesRef = useRef([]);

    useLayoutEffect(() => {
        if (!sectionRef.current) return;

        let ctx = gsap.context(() => {
            // Pin the entire section for smooth scroll effect
            ScrollTrigger.create({
                trigger: sectionRef.current,
                start: "top top",
                // pin: true,
                pinSpacing: false,
                toggleActions: "play none none none",
            });

            // Title and Text Animation
            ScrollTrigger.create({
                trigger: titleRef.current,
                start: "top 90%",
                toggleActions: "play none none none",
                animation: gsap.from([titleRef.current, textRef.current], {
                    opacity: 0,
                    y: 50,
                    duration: 0.6,
                    ease: "power3.out",
                    stagger: 0.2,
                }),
            });

            // Cards Animation (Fade-in and Scale-up)
            ScrollTrigger.create({
                trigger: cardsRef.current,
                start: "top 80%",
                toggleActions: "play none none none",
                animation: gsap.from(cardsRef.current, {
                    opacity: 0,
                    y: 50,
                    scale: 0.8,
                    stagger: 0.2,
                    duration: 1.2,
                    ease: "back.out(1.5)",
                }),
            });

            // Images Animation (Slide-in from Bottom)
            ScrollTrigger.create({
                trigger: imagesRef.current,
                start: "top 85%",
                toggleActions: "play none none none",
                animation: gsap.from(imagesRef.current, {
                    opacity: 0,
                    y: 50,
                    duration: 1.2,
                    ease: "power3.out",
                    stagger: 0.2,
                }),
            });

        }, sectionRef);

        return () => {
            if (ctx) ctx.revert();
        };
    }, []);

    return (
        <>
            <div ref={sectionRef} className={style.wrapper}>
                <div className={style.contentBox}>
                    <div className={style.flexRow}>
                        <div className={style.textSection}>
                            <h1 ref={titleRef} className={style.title}>We're shaping the future of trading</h1>
                            <p ref={textRef} className={style.description}>
                                Welcome to SWINGALGO, where innovation meets financial markets. Our mission is to empower traders with cutting-edge tools, real-time insights, and a seamless trading experience. Whether you're a beginner or an experienced trader, we provide the resources you need to make informed decisions and stay ahead of the market.
                                <p ref={textRef} className={style.description2}>We aim to revolutionize the trading industry by combining advanced analytics, real-time data, and AI-driven strategies to maximize trading potential. Our goal is to create a transparent and accessible ecosystem for traders worldwide.</p>
                            </p>
                        </div>
                        <div className={style.cardGrid}>
                            <div ref={el => cardsRef.current[0] = el} className={`${style.card} ${style.card1}`}>
                                <img className={style.icon} />
                                <span>Real-Time Market Data</span>
                            </div>
                            <div ref={el => cardsRef.current[1] = el} className={`${style.card} ${style.card2}`}>
                                <img className={style.icon} />
                                <span>Technical Analysis Tools</span>
                            </div>
                            <div ref={el => cardsRef.current[2] = el} className={`${style.card} ${style.card3}`}>
                                <img className={style.icon} />
                                <span>Seamless User Experience</span>
                            </div>
                            <div ref={el => cardsRef.current[3] = el} className={`${style.card} ${style.card4}`}>
                                <img className={style.icon} />
                                <span>Community & Learning</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ✅ Image Grid Section */}
           

            <div className={style.contentBox}>
                <h4 className={style.additionalText}>
                    We are a passionate team of traders, analysts, and developers dedicated to building an intuitive and high-performance trading environment. Our expertise in financial markets and technology helps us deliver top-tier trading solutions.
                </h4>
            </div>
        </>
    );
};

export default Aboutus;
